import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgAe48Rounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  "aria-label": "United Arab Emirates",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#e7e7e7",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#e73b36",
  d: "m8.64 21.42 1.93-9.58-1.93-9.26a10 10 0 0 0 0 18.84"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21.31 8.35 15.2 6.78 8.52 8.52v7l6.71 1.44 6.09-1.3a10 10 0 0 0 0-7.27z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#49a948",
  d: "M8.52 2.62v5.9h12.86a10 10 0 0 0-12.86-5.9"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#151515",
  d: "M21.38 15.48a10 10 0 0 1-12.86 5.9v-5.9z"
}));

export { SvgAe48Rounded as default };
//# sourceMappingURL=Ae48Rounded.js.map
